export default function PreviewHighlights({ config }) {
  const h = config?.website?.highlights || {};
  const items = (h.items || []).filter((x) => x.enabled);

  return (
    <section style={{ padding: "0 24px 26px" }}>
      <div
        style={{
          borderRadius: "var(--ns-radius-lg)",
          background: "var(--ns-card)",
          border: "1px solid var(--ns-card-border)",
          boxShadow: "var(--ns-shadow)",
          padding: 18
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginBottom: 12
          }}
        >
          <div
            style={{
              width: 10,
              height: 10,
              borderRadius: 999,
              background: "var(--ns-primary)"
            }}
          />
          <h3 style={{ margin: 0, color: "var(--ns-ink)", fontWeight: 950, fontSize: 18 }}>
            {h.title || "Highlights"}
          </h3>
        </div>

        {items.length === 0 ? (
          <div style={{ color: "var(--ns-muted)", fontSize: 13 }}>
            Add highlights to show premium chips here.
          </div>
        ) : (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
            {items.map((it) => (
              <div
                key={it.key}
                style={{
                  padding: "10px 14px",
                  borderRadius: 999,
                  background: "rgba(15,23,42,0.04)",
                  border: "1px solid rgba(15,23,42,0.08)",
                  color: "rgba(11,18,32,0.92)",
                  fontWeight: 900,
                  fontSize: 13,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 10
                }}
              >
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: 999,
                    background: "var(--ns-primary)",
                    display: "inline-block"
                  }}
                />
                {it.label}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
